export default __webpack_public_path__ + "static/media/AGC_Question_Paper_Class_4.d9342dfe.pdf";